import { REVIEWS_WIDGET_NAMES } from "@/constants/widget-names";
import { QuestionsFormModalWidgetDefinition } from "@apps/reviews/definitions";
import AnalyticsEventsCollectorInterface from "@modules/analytics_events_collector/AnalyticsEventsCollector/AnalyticsEventsCollectorInterface";
import { AnalyticsEventsFactory } from "@modules/analytics_events_collector/AnalyticsEventsCollector/AnalyticsEventsFactory";
import { DynamicImportManager } from "@modules/dynamic_import/DynamicImportManager";
import WidgetInjectedSdkEvent from "@modules/sdk/common_sdk/events/WidgetInjectedSdkEvent";
import { dispatchSdkEvent } from "@modules/sdk/helpers";
import MutationObserverInjector from "@ui-utils/Injector/MutationObserverInjector";

import { LoggerInterface } from "@interfaces/LoggerInterface";

class QuestionsFormModalWidgetInjector {
    constructor(
        private readonly placeholderSelector: string,
        private readonly logger: LoggerInterface,
        private readonly eventsCollector: AnalyticsEventsCollectorInterface,
        private readonly analyticsEventsFactory: AnalyticsEventsFactory,
        private readonly dynamicImportManager: DynamicImportManager,
        private readonly moi: MutationObserverInjector
    ) {}

    start(): void {
        this.logger.debug("QuestionsFormModalWidgetInjector start", {
            placeholderSelector: this.placeholderSelector,
        });

        const targets$ = this.moi.register({
            targetSelector: this.placeholderSelector,
        });

        targets$.subscribe((placeholder) => {
            this.logger?.debug(
                "QuestionsFormModalWidgetInjector found placeholder",
                {
                    placeholder,
                }
            );

            void (async () => {
                const QuestionsFormModalWidget =
                    await this.dynamicImportManager.importDefault(
                        QuestionsFormModalWidgetDefinition
                    );

                const widget = new QuestionsFormModalWidget(
                    {
                        target: placeholder,
                    },
                    this.logger
                );

                await widget.init();

                this.eventsCollector.pushEvent(
                    this.analyticsEventsFactory.createWidgetInjected(
                        REVIEWS_WIDGET_NAMES.QUESTIONS_FORM_MODAL_WIDGET
                    )
                );

                dispatchSdkEvent(
                    new WidgetInjectedSdkEvent(
                        REVIEWS_WIDGET_NAMES.QUESTIONS_FORM_MODAL_WIDGET
                    )
                );
            })();
        });
    }
}

export default QuestionsFormModalWidgetInjector;
